<div id="tenantPage" *appHasPermission="{ permissions: [permissions.allPermissions.TENANT_READ] }">
  <div class="widget tenantList">
    @if (timeOut()) {
      <app-timeout></app-timeout>
    } @else if (loading()) {
      <div class="flex h-full justify-content-center align-items-center">
        <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
      </div>
    } @else {
      @if (tenants()) {
        <div class="list-compact-rows selectable">
          <span class="listTitle">
            {{ "admin.tenant_administration.tenants" | translate }}
          </span>
          <div class="listItems">
            @for (tenant of tenants(); track tenant.id) {
              <div
                (click)="onClickTenant(tenant)"
                class="listRow"
                [ngClass]="{
                  selected: selectedTenantDetails() && tenant.id === selectedTenantDetails()!.id,
                }"
              >
                <span>{{ tenant.label }}</span>
                <div class="actionButtonGroup">
                  <app-svg-icon
                    *appHasPermission="{
                      permissions: [permissions.allPermissions.TENANT_UPDATE],
                    }"
                    (click)="openEditTenant($event, tenant)"
                    iconName="edit"
                    iconColor="primary"
                    iconSize="xs"
                    class="pointer"
                  ></app-svg-icon>

                  <app-svg-icon
                    *appHasPermission="{
                      permissions: [permissions.allPermissions.TENANT_DELETE],
                    }"
                    (click)="openConfirmPopupTenant($event, tenant.id)"
                    iconName="trash"
                    iconColor="primary"
                    iconSize="xs"
                    class="pointer"
                  ></app-svg-icon>
                </div>
              </div>
            }
          </div>
          <app-button
            *appHasPermission="{
              permissions: [permissions.allPermissions.TENANT_CREATE],
            }"
            [buttonText]="translate.instant('admin.tenant_administration.add_tenant')"
            [buttonIcon]="'plus'"
            (click)="openAddTenant()"
          ></app-button>
        </div>
      }
    }
  </div>

  @if (selectedTenantDetails()) {
    <div
      class="widget controllerCatalogList"
      *appHasPermission="{
        permissions: [permissions.allPermissions.TENANT_UPDATE],
      }"
    >
      <div class="list-compact-rows">
        <span class="listTitle">
          {{ "admin.tenant_administration.controller_catalog_assign.manufacturers" | translate }}</span
        >

        <ngx-simplebar [options]="{ autoHide: false }" class="listItems">
          @for (manufacturer of selectedTenantDetails()!.manufacturers; track manufacturer.id) {
            <div class="listRow">
              <span>
                {{ manufacturer.label }}
              </span>
              <div class="actionButtonGroup">
                <app-svg-icon
                  (click)="deleteManufacturer(manufacturer.id)"
                  iconName="trash"
                  iconColor="primary"
                  iconSize="xs"
                  class="pointer"
                ></app-svg-icon>
              </div>
            </div>
          }
        </ngx-simplebar>
        <app-button
          (click)="openAddManufacturer()"
          buttonText="admin.tenant_administration.controller_catalog_assign.add_manufacturer"
        ></app-button>
      </div>

      <div class="list-compact-rows">
        <span class="listTitle"> {{ "admin.tenant_administration.controller_catalog_assign.models" | translate }}</span>
        <ngx-simplebar [options]="{ autoHide: false }" class="listItems">
          @for (model of selectedTenantDetails()!.models; track model) {
            <div class="listRow">
              <span>
                {{ model.label }}
              </span>
              <div class="actionButtonGroup">
                @if (canOverrideModel) {
                  <app-svg-icon
                    (click)="overrideModel(model.id)"
                    iconName="replace"
                    iconColor="primary"
                    iconSize="xs"
                    [pTooltip]="translate.instant('admin.tenant_administration.fault_list_override')"
                    tooltipPosition="bottom"
                    class="pointer"
                  ></app-svg-icon>
                }
                <app-svg-icon
                  (click)="deleteModel(model.id)"
                  iconName="trash"
                  iconColor="primary"
                  iconSize="xs"
                  class="pointer"
                ></app-svg-icon>
              </div>
            </div>
          }
        </ngx-simplebar>
        <app-button
          buttonText="admin.tenant_administration.controller_catalog_assign.add_model"
          (click)="openAddModel()"
        ></app-button>
      </div>
    </div>
    <!-- User List -->
    <div
      class="widget userList"
      *appHasPermission="{
        permissions: [permissions.allPermissions.USER_READ],
      }"
    >
      <div class="list-compact-rows">
        <div class="listHeader">
          <span>{{ "admin.tenant_administration.selected_tenant" | translate }}</span>
          <span class="listHeaderTitle">
            {{ selectedTenantDetails()!.label }}
          </span>
        </div>
        <span class="listTitle">
          {{ "admin.tenant_administration.users" | translate }}
        </span>
        @if (selectedTenantDetails()!.users && selectedTenantDetails()!.users!.length > 0) {
          <ngx-simplebar [options]="{ autoHide: false }" class="listItems">
            @for (user of selectedTenantDetails()!.users; track user.id) {
              <div class="listRow">
                <div class="flex flex-column">
                  <span>{{ user.firstName + " " + user.lastName }}</span>
                  <span class="font-size-sm greyText">{{ user.email }}</span>
                </div>

                <div class="actionButtonGroup">
                  <app-svg-icon
                    *appHasPermission="{
                      permissions: [permissions.allPermissions.USER_UPDATE],
                    }"
                    (click)="openEditUser(user.id)"
                    iconName="edit"
                    iconColor="primary"
                    iconSize="xs"
                    class="pointer"
                  ></app-svg-icon>
                  <app-svg-icon
                    *appHasPermission="{
                      permissions: [permissions.allPermissions.USER_DELETE],
                    }"
                    (click)="openConfirmPopupUser($event, user.id)"
                    iconName="trash"
                    iconColor="primary"
                    iconSize="xs"
                    class="pointer"
                  ></app-svg-icon>
                </div>
              </div>
            }
          </ngx-simplebar>
        } @else {
          <span class="no-entries">{{ "common.no_entries" | translate }}</span>
        }

        <app-button
          *appHasPermission="{
            permissions: [permissions.allPermissions.USER_CREATE],
          }"
          [buttonText]="translate.instant('admin.tenant_administration.add_user')"
          [buttonIcon]="'plus'"
          (click)="openAddUser()"
        ></app-button>
      </div>
    </div>

    <!-- Cores List -->
    <div
      class="widget coreList"
      *appHasPermission="{
        permissions: [permissions.allPermissions.CORE_READ],
      }"
    >
      <div class="list-compact-rows">
        <span class="listTitle">
          {{ "admin.tenant_administration.cores" | translate }}
        </span>
        @if (selectedTenantDetails()!.cores && selectedTenantDetails()!.cores!.length > 0) {
          <ngx-simplebar [options]="{ autoHide: false }" class="listItems">
            @for (core of selectedTenantDetails()!.cores; track core.id) {
              <div class="listRow">
                <span>{{ core.serialNumber }}</span>
                <div class="actionButtonGroup">
                  <app-svg-icon
                    (click)="openConfirmPopupCore($event, core.id)"
                    iconName="trash"
                    iconColor="primary"
                    iconSize="xs"
                    class="pointer"
                  ></app-svg-icon>
                </div>
              </div>
            }
          </ngx-simplebar>
        } @else {
          <span class="no-entries">{{ "common.no_entries" | translate }}</span>
        }

        <app-button
          *appHasPermission="{
            permissions: [permissions.allPermissions.CORE_CREATE],
          }"
          [buttonText]="translate.instant('admin.tenant_administration.add_core')"
          [buttonIcon]="'plus'"
          (click)="openAddCore()"
        ></app-button>
      </div>
    </div>
  }
</div>
